import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <g id="组_9220" data-name="组 9220" transform="translate(-1163 -2136)">
      <path
        id="路径_9245"
        data-name="路径 9245"
        d="M12.143,7.857h6.429A1.426,1.426,0,0,1,20,9.286v9.286A1.426,1.426,0,0,1,18.571,20H9.286a1.426,1.426,0,0,1-1.429-1.429V12.143H1.429A1.426,1.426,0,0,1,0,10.714V1.429A1.426,1.426,0,0,1,1.429,0h9.286a1.426,1.426,0,0,1,1.429,1.429Zm0,1.429v1.429a1.426,1.426,0,0,1-1.429,1.429H9.286v5.715a.713.713,0,0,0,.714.714h7.858a.714.714,0,0,0,.714-.714V10a.714.714,0,0,0-.714-.714ZM3.234.93h8.027c0,.394-.394,9.612,0,9.612L10,10.714A.714.714,0,0,0,10.714,10V2.143A.714.714,0,0,0,10,1.429H2.143c-.189,0,1.091-.688,1.091-.5ZM2.857,7.6V4H5.374V2.5H6.417c.143.021.215.041.215.061a.236.236,0,0,1-.031.092,1.658,1.658,0,0,0-.092.583V4H9.18V7.5H8.044V7.042H6.509v2.64H5.4V7.042H3.9V7.6ZM3.9,4.864v1.35H5.4V4.864Zm4.144,1.35V4.864H6.509v1.35H8.044Zm4.55,10.893H11.429l2.056-5.678h1.443l1.994,5.679H15.695l-.43-1.2H13.024l-.429,1.2h0Zm.737-2.149h1.626l-.767-2.424h-.03l-.829,2.424Zm5.24-9.244H17.143a2.857,2.857,0,0,0-2.857-2.857V1.429a4.286,4.286,0,0,1,4.286,4.286ZM1.429,14.286H2.857a2.857,2.857,0,0,0,2.857,2.857v1.429a4.286,4.286,0,0,1-4.286-4.286Z"
        transform="translate(1163 2136)"
        fill="#888888"
      />
      <path
        id="路径_9246"
        data-name="路径 9246"
        d="M2.857,7.6V4H5.374V2.5H6.417c.143.021.215.041.215.061a.236.236,0,0,1-.031.092,1.658,1.658,0,0,0-.092.583V4H9.18V7.5H8.044V7.042H6.509v2.64H5.4V7.042H3.9V7.6ZM3.9,4.864v1.35H5.4V4.864Zm4.144,1.35V4.864H6.509v1.35H8.044Z"
        transform="translate(1163.003 2136)"
        fill="#fff"
      />
    </g>
  </svg>
);

export default CMP;
